export default __webpack_public_path__ + "static/media/Silk-Serif-SemiBold-Italic.744d7b38.otf";